import api from './api';

export interface PlanilhaCapex {
  id: string;
  numero: number;
  oi: string;
  numeroPlanilha: number;
  revisao: string;
  dataApovacao: Date;
}

export interface OrcadoEconomicoCapexAnoMes {
  id: string;
  Ano: number;
  Mes: number;
  Valor: number;
}

export interface OrcamentoPlanilha {
  projetoId: string;
  revisao: number;
  numero: number;
  nome: string;
  id: string;
  status: string;
  numberIndex: number;
  dataAprovacao: string;
}

export interface OrcamentoAcronimoPacote {
  ordemId: string;
  acronimoId: string;
  projetoId: string;
}

export interface ResumoCapex {
  projetoId: string;
  numero: number;
  revisao: number;
  oi: string;
  codigoPacote: string;
  nome: string;
  valor: number;
  valorTotal: number;
  valorCurrency: string;
  valorTotalCurrency: string;
  dataAprovacao: string;
  index: number;
}

export interface ResumoRfa {
  projetoId: string;
  numero: number;
  revisao: number;
  oi: string;
  codigoPacote: string;
  nome: string;
  valor: number;
  valorTotal: number;
  valorCurrency: string;
  valorTotalCurrency: string;
  dataAprovacao: string;
  index: number;
}

export interface OrcadoAnoMes {
  resultDataTabel: ResumoAnoMes[];
  valorTotalCurrencyArray: [];
  numero: number;
  revisao: number;
  dataAprovacao: string;
  oi: string;
  planilhaId: string;
  codigoPacote: string;
  anos: number[];
}

export interface ResumoAnoMes {
  projetoId: string;
  numero: number;
  revisao: number;
  oi: string;
  codigoPacote: string;
  nome: string;
  valor: number;
  valorTotal: number;
  valorTotalCurrency: string;
  dataAprovacao: string;
  valorCurrencyArray: [];
  valorTotalCurrencyArray: [];
  ano: string;
  planilhaId: string;
  index: number;
}

export interface ValorTotalAno {
  valorTotalCurrency: string;
  ano: string;
  index: number;
}

// ano: 2021;
// index: 1;
// valorTotal: 0;
// valorTotalCurrency: 'R$ 2.622.503,00';

export const getAllPlanilhaCapexOrcadoEconomicoCapexAnoMesResultForProjetoId = (projetoId: any) =>
  api.get<any[]>(`orcamentos/getAllPlanilhaCapexOrcadoEconomicoCapexAnoMesResultForProjetoId/${projetoId}`);

export const GetAllPlanilhaRfaAnoMes = (projetoId: any) =>
  api.get<any[]>(`orcamentos/GetAllPlanilhaRfaAnoMes/${projetoId}`);

export const GetAllPlanilhaRfaAntigas = (projetoId: any) =>
  api.get<any[]>(`orcamentos/GetAllPlanilhaRfaAntigas/${projetoId}`);

export const GetAllPlanilhaCapexAntigas = (projetoId: any) =>
  api.get<any[]>(`orcamentos/GetAllPlanilhaCapexAntigas/${projetoId}`);

export const getAllResumoPlanilhaCapexProjeto = (projetoId: any) =>
  api.get<ResumoCapex[]>(`orcamentos/GetAllResumoPlanilhaCapexProjeto/${projetoId}`);

export const getAllResumoPlanilhaRfaProjeto = (projetoId: any) =>
  api.get<ResumoRfa[]>(`orcamentos/GetAllResumoPlanilhaRfaProjeto/${projetoId}`);

export const getAllResumoPlanilhaAnoProjeto = (projetoId: any) =>
  api.get<OrcadoAnoMes>(`orcamentos/GetAllResumoPlanilhaAnoMesProjeto/${projetoId}`);
